// extracted by mini-css-extract-plugin
module.exports = {"dp-flex":"dp-flex___ZZYsU","dp-flex-spaceBetween":"dp-flex-spaceBetween___F91s8"};